<template>
  <div>
    <div class="add-container">
      <div class="add-title">
        <h1>添加收货地址</h1>
      </div>
      <div class="add-box">
        <Form
          :model="formData"
          label-position="left"
          :label-width="100"
          :rules="ruleInline"
          ref="formDynamic"
        >
          <FormItem label="收件人" prop="real_name">
            <i-input v-model="formData.real_name" size="large"></i-input>
          </FormItem>
          <FormItem label="收件地区" prop="address">
            <div @click.stop="show2 = true">
              <i-input v-model="modelAdress" size="large"></i-input>
            </div>
            <CitySelect
              v-model="show2"
              :callback="result2"
              :items="district"
              provance=""
              city=""
              area=""
            ></CitySelect>
          </FormItem>
          <FormItem label="详细地址" prop="detail">
            <i-input v-model="formData.detail" size="large"></i-input>
          </FormItem>
          <FormItem label="手机号码" prop="phone">
            <i-input v-model="formData.phone" size="large"></i-input>
          </FormItem>
        </Form>
      </div>
      <div class="setAddress">
        <div class="title">
          设置为默认地址
        </div>
        <i-switch v-model="switch1" @on-change="changeSwitch" />
      </div>
      <div class="add-submit">
        <Button type="primary" @click="addNewAddress">添加地址</Button>
      </div>
    </div>
  </div>
</template>

<script>
import { postAddress } from "@api/user";
import { CitySelect } from "vue-ydui/dist/lib.rem/cityselect";
import District from "ydui-district/dist/jd_province_city_area_id";
export default {
  name: "AddAddress",
  data() {
    return {
      formData: {
        real_name: "",
        address: {
          province: "",
          city: "",
          area: ""
        },
        phone: "",
        detail: "",
        post_code: "",
        is_default: 0
      },
      ruleInline: {
        real_name: [{ required: true, message: "请输入姓名", trigger: "blur" }],
        detail: [{ required: true, message: "请输入地址", trigger: "blur" }],
        phone: [
          { required: true, message: "手机号不能为空", trigger: "blur" },
          {
            type: "string",
            pattern: /^1[3|4|5|7|8][0-9]{9}$/,
            message: "手机号格式出错",
            trigger: "blur"
          }
        ]
      },
      district: District,
      show2: false,
      modelAdress: "选择收货地区",
      switch1: false
    };
  },
  methods: {
    getProvince(data) {
      this.formData.province = data.value;
    },
    getCity(data) {
      this.formData.city = data.value;
    },
    getArea(data) {
      this.formData.area = data.value;
    },
    result2(ret) {
      this.modelAdress =
        ret.itemName1 + " " + ret.itemName2 + " " + ret.itemName3;
      this.formData.address.province = ret.itemName1;
      this.formData.address.city = ret.itemName2;
      this.formData.address.district = ret.itemName3;
    },
    addNewAddress() {
      this.$refs.formDynamic.validate(valid => {
        if (valid) {
          postAddress(this.formData).then(res => {
            if (res.status === 200) {
              this.$Message.success("添加成功");
              this.$router.push({ path: "/home/myAddress" });
            }
          });
        }
      });
    },
    changeSwitch(status) {
      if (status) {
        this.formData.is_default = 1;
      } else {
        this.formData.is_default = 0;
      }
    }
  },
  components: {
    CitySelect
  }
};
</script>

<style scoped>
.add-container {
  margin: 15px auto;
  width: 60%;
  min-width: 600px;
}
.add-title {
  margin-bottom: 15px;
  text-align: center;
}
.add-submit {
  display: flex;
  justify-content: center;
}
.setAddress {
  display: flex;
  line-height: 24px;
}
.title {
  margin-right: 20px;
}
</style>
